import React from "react";
import { NavLink } from "react-router-dom";

const projects = [
  {
    image: require("./../../images/projects/ultratech.png"),
    title: "ULTRATECH",
    category: "Cement",
  },
  {
    image: require("./../../images/projects/adani.png"),
    title: "ADANI",
    category: "Cement",
  },
  {
    image: require("./../../images/projects/shree.png"),
    title: "Shree Cement",
    category: "Cement",
  },
  {
    image: require("./../../images/projects/wonder.png"),
    title: "Wonder Cement",
    category: "Cement",
  },
  {
    image: require("./../../images/projects/acc.png"),
    title: "ACC Cement",
    category: "Cement",
  },
  {
    image: require("./../../images/projects/jksuper.png"),
    title: "JK Super Cement",
    category: "Cement",
  },
  {
    image: require("./../../images/projects/jklakshmi.png"),
    title: "JK Lakshmi Cement",
    category: "Cement",
  },
  {
    image: require("./../../images/projects/birlauttam.png"),
    title: "Birla Uttam Cement",
    category: "Cement",
  },
  {
    image: require("./../../images/projects/ashirwaad.png"),
    title: "Ashirwad Plumbing",
    category: "Plumbing",
  },
  {
    image: require("./../../images/projects/myk.png"),
    title: "MYK Laticrete",
    category: "Plumbing",
  },
  {
    image: require("./../../images/projects/rathi.png"),
    title: "Rathi Steel",
    category: "Steel",
  },
  {
    image: require("./../../images/projects/tata.png"),
    title: "Tata Steel",
    category: "Steel",
  },
  {
    image: require("./../../images/projects/jsw.png"),
    title: "JSW Steel",
    category: "Steel",
  },
  {
    image: require("./../../images/projects/sail.png"),
    title: "Sail Steel",
    category: "Steel",
  },
  {
    image: require("./../../images/projects/finolex.png"),
    title: "Finolex Cables",
    category: "Electrical",
  },
  {
    image: require("./../../images/projects/berger.png"),
    title: "Berger Paints",
    category: "Paint",
  },
  {
    image: require("./../../images/projects/putty.png"),
    title: "Birla White Putty",
    category: "Putty",
  },
];

class OurProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      translateX: 0,
      isPaused: false,
    };
    this.sliderRef = React.createRef();
    this.animationId = null;
    this.speed = 1; // pixels per frame
  }

  componentDidMount() {
    this.startSlider();
  }

  componentWillUnmount() {
    this.stopSlider();
  }

  startSlider = () => {
    const animate = () => {
      if (!this.state.isPaused) {
        this.setState(prevState => {
          // Calculate the width of one set of logos (we'll duplicate them)
          const containerWidth = projects.length * 170; // 150px width + 20px margin
          let newTranslateX = prevState.translateX - this.speed;

          // Reset position when we've scrolled through all original items
          if (Math.abs(newTranslateX) >= containerWidth) {
            newTranslateX = 0;
          }

          return { translateX: newTranslateX };
        });
      }
      this.animationId = requestAnimationFrame(animate);
    };

    this.animationId = requestAnimationFrame(animate);
  };

  stopSlider = () => {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }
  };

  pauseSlider = () => {
    this.setState({ isPaused: true });
  };

  resumeSlider = () => {
    this.setState({ isPaused: false });
  };

  render() {
    const { translateX } = this.state;

    // Duplicate projects array for infinite scroll effect
    const duplicatedProjects = [...projects, ...projects];

    return (
      <>
        <div
          className="section-full mobile-page-padding p-t80 p-b80"
          style={{ backgroundColor: "#f8f9fb" }}
        >
          <div className="container">
            {/* TITLE START */}
            <div className="section-head text-center">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "700",
                  color: "#333",
                  marginBottom: "15px",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                Our <span style={{ color: "#3fa4ca" }}>Trusted Partners</span>
              </h2>
              <div
                style={{
                  width: "80px",
                  height: "4px",
                  backgroundColor: "#3fa4ca",
                  margin: "0 auto 20px",
                  borderRadius: "2px",
                }}
              />
              <p
                style={{
                  fontSize: "1.1rem",
                  color: "#666",
                  maxWidth: "600px",
                  margin: "0 auto 40px",
                  lineHeight: "1.6",
                }}
              >
                Leading brands that trust our distribution network for quality
                construction materials
              </p>
            </div>
            {/* TITLE END */}

            {/* LOGO SLIDER START */}
            <div
              style={{
                position: "relative",
                overflow: "hidden",
                backgroundColor: "white",
                borderRadius: "15px",
                padding: "40px 0",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                border: "1px solid #f0f0f0",
              }}
              onMouseEnter={this.pauseSlider}
              onMouseLeave={this.resumeSlider}
            >
              <div
                ref={this.sliderRef}
                style={{
                  display: "flex",
                  alignItems: "center",
                  transform: `translateX(${translateX}px)`,
                  width: "max-content",
                  gap: "20px",
                  paddingLeft: "20px",
                }}
              >
                {duplicatedProjects.map((project, index) => (
                  <div
                    key={`${project.title}-${index}`}
                    style={{
                      width: "150px",
                      height: "120px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "15px",
                      backgroundColor: "#fafafa",
                      borderRadius: "12px",
                      border: "2px solid #f0f0f0",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      flexShrink: 0,
                    }}
                    onMouseOver={e => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 15px 35px rgba(63, 164, 202, 0.15)";
                      e.currentTarget.style.borderColor = "#3fa4ca";
                    }}
                    onMouseOut={e => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.borderColor = "#f0f0f0";
                    }}
                    title={project.title}
                  >
                    <img
                      src={project.image}
                      alt={project.title}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        filter: "grayscale(20%)",
                        transition: "filter 0.3s ease",
                      }}
                      onMouseOver={e => {
                        e.target.style.filter = "grayscale(0%)";
                      }}
                      onMouseOut={e => {
                        e.target.style.filter = "grayscale(20%)";
                      }}
                    />
                  </div>
                ))}
              </div>

              {/* Gradient overlays for smooth edge effect */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100px",
                  height: "100%",
                  background: "linear-gradient(to right, white, transparent)",
                  pointerEvents: "none",
                  zIndex: 1,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "100px",
                  height: "100%",
                  background: "linear-gradient(to left, white, transparent)",
                  pointerEvents: "none",
                  zIndex: 1,
                }}
              />
            </div>
            {/* LOGO SLIDER END */}

            {/* STATS SECTION */}
            <div style={{ marginTop: "60px" }}>
              <div className="row text-center">
                <div className="col-md-3 col-sm-6 mb-4">
                  <div
                    style={{
                      padding: "30px 20px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
                      border: "1px solid #f0f0f0",
                    }}
                  >
                    <h3
                      style={{
                        color: "#3fa4ca",
                        fontSize: "2.5rem",
                        fontWeight: "bold",
                        margin: "0 0 10px",
                      }}
                    >
                      15+
                    </h3>
                    <p
                      style={{
                        color: "#666",
                        margin: 0,
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      Region We Serve
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 mb-4">
                  <div
                    style={{
                      padding: "30px 20px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
                      border: "1px solid #f0f0f0",
                    }}
                  >
                    <h3
                      style={{
                        color: "#3fa4ca",
                        fontSize: "2.5rem",
                        fontWeight: "bold",
                        margin: "0 0 10px",
                      }}
                    >
                      670+
                    </h3>
                    <p
                      style={{
                        color: "#666",
                        margin: 0,
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      Satisfied Clients
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 mb-4">
                  <div
                    style={{
                      padding: "30px 20px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
                      border: "1px solid #f0f0f0",
                    }}
                  >
                    <h3
                      style={{
                        color: "#3fa4ca",
                        fontSize: "2.5rem",
                        fontWeight: "bold",
                        margin: "0 0 10px",
                      }}
                    >
                      1500
                    </h3>
                    <p
                      style={{
                        color: "#666",
                        margin: 0,
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      Project Complete
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 mb-4">
                  <div
                    style={{
                      padding: "30px 20px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
                      border: "1px solid #f0f0f0",
                    }}
                  >
                    <h3
                      style={{
                        color: "#3fa4ca",
                        fontSize: "2.5rem",
                        fontWeight: "bold",
                        margin: "0 0 10px",
                      }}
                    >
                      24/7
                    </h3>
                    <p
                      style={{
                        color: "#666",
                        margin: 0,
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      Customer Support
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default OurProject;
